import { Link } from "react-router-dom";
import { useUser, UserButton } from '@clerk/react';
import { useSubscription } from '@clerk/react/experimental';
import { useEffect } from 'react';

const SUBSCRIPTION_POLL_MS = 60_000; // revalidate every 60 seconds

export default function Header() {
  const { isSignedIn, user } = useUser();
  const { data: subscription, revalidate } = useSubscription();

  // Periodically reload the user session token and revalidate subscription
  // so stale premium access can't persist in an open browser tab after cancellation
  useEffect(() => {
    if (!isSignedIn) return;
    const id = setInterval(async () => {
      await user?.reload();
      await revalidate?.();
    }, SUBSCRIPTION_POLL_MS);
    return () => clearInterval(id);
  }, [isSignedIn, user, revalidate]);

  const isPremium = subscription?.subscriptionItems?.some(
    item => !item.plan.isDefault && item.status === 'active'
  ) ?? false;

  const tierBadge = isSignedIn ? (
    <span style={{
      fontSize: '0.7rem',
      fontWeight: '700',
      padding: '2px 7px',
      borderRadius: '10px',
      background: isPremium ? '#ffd600' : '#444',
      color: isPremium ? '#000' : '#aaa',
      letterSpacing: '0.04em',
      marginRight: '6px',
      whiteSpace: 'nowrap',
    }}>
      {isPremium ? '★ PREMIUM' : 'FREE'}
    </span>
  ) : null;

  return (
    <header className="header">
      <div className="header-left">
        <img 
          src={process.env.PUBLIC_URL + '/kenoanalyzerlogo192.png'} 
          alt="Keno Analyzer Logo" 
          className="site-logo"
          style={{ height: '36px', width: '36px', marginRight: '12px' }}
        />
        <h1 className="site-title">Keno Analyzer</h1>
      </div>

      <nav className="header-nav">
        <Link to="/">Home</Link>
        <Link to="/analyzer">Keno Analyzer</Link>
        <Link to="/about">About</Link>
        <Link to="/pricing">Pricing</Link>

        {!isSignedIn && (
          <>
            <Link to="/login">Login</Link>
            <Link to="/join" className="cta-link">Join Free</Link>
          </>
        )}

        {isSignedIn && (
          <div className="user-avatar" style={{ display: 'flex', alignItems: 'center' }}>
            {tierBadge}
            <UserButton afterSignOutUrl="/" />
          </div>
        )}
      </nav>
    </header>
  );
}